export default "__VITE_ASSET__C4bFZ1AN__"